/* eslint-disable max-len */
const ApiUrl = process.env.NEXT_PUBLIC_API_URL;

const UrlParamsReplace = (url, params = {}) => {
    let urlWithPrefix = `${ApiUrl}${url}`;
    if (params) {
        Object.keys(params).forEach(
            (key) => (urlWithPrefix = urlWithPrefix.replace(`:${key}`, params[key]))
        );
    }
    return urlWithPrefix;
};

export const CREATE_CONTACT = UrlParamsReplace('/contacts');
export const GET_IRS_BOND_LIVE_PRICE_URL = (query) => {
    const params = new URLSearchParams(
        Object.entries(query || {}).filter(([, v]) => v !== undefined && v !== null && v !== '')
    ).toString();
    return UrlParamsReplace(`/irs-bonds/live-price${params ? `?${params}` : ''}`);
};

export const USER_LOGIN_URL = UrlParamsReplace('/login');
export const CREATE_COMPANY = () => UrlParamsReplace('/companies');
export const GET_ALL_COMPANIES = ({ offset, limit, role }) => UrlParamsReplace('/companies?offset=:offset&limit=:limit&role=:role', {
    offset,
    limit,
    role
});

export const GET_UPLOAD_PRE_SIGNED_URL = UrlParamsReplace(
    '/aws/get-upload-pre-signed-url'
);
export const CREATE_BOND_URL = UrlParamsReplace('/bonds');
export const CREATE_USER_URL = UrlParamsReplace('/user');
export const UPDATE_USER_URL = (id) => UrlParamsReplace('/user/:id', { id });
export const CREATE_BOND_PRICE_HISTORY_URL = UrlParamsReplace(
    '/bond-price-history'
);
export const RESEND_WELCOME_EMAIL = (id) => UrlParamsReplace('/resend-welcome-email/:id', { id });

export const UPDATE_COMPANY_URL = (id) => UrlParamsReplace('/companies/:id', { id });
export const GET_PAGINATED_USER_URL = (offset, limit, role, phrase) => UrlParamsReplace(
    '/users?offset=:offset&limit=:limit&role=:role&phrase=:phrase',
    {
        offset,
        limit,
        role,
        phrase
    }
);
export const GET_PAGINATED_USER_FOR_COMPLIANCE_URL = (offset, limit, phrase) => UrlParamsReplace(
    '/compliance/users?offset=:offset&limit=:limit&phrase=:phrase',
    { offset, limit, phrase }
);
export const GET_CHAT_TOKEN_FOR_COMPLIANCE_URL = (userId) => UrlParamsReplace('/compliance/auth?userId=:userId', { userId });
export const GET_HOOTS_FOR_COMPLIANCE_URL = () => UrlParamsReplace('/compliance/hoot');
export const GET_HOOT_SEARCH_USER_FOR_COMPLIANCE_URL = ({
    phrase,
    sameCompany
}) => UrlParamsReplace(
    '/compliance/users/search?phrase=:phrase&sameCompany=:sameCompany',
    { phrase, sameCompany }
);
export const GET_HOOT_SIGNED_BY_ID_URL = ({ id }) => UrlParamsReplace('/compliance/hoot/signed/:id', { id });

export const CREATE_SECTOR_URL = () => UrlParamsReplace('/sectors');
export const UPDATE_SECTOR_URL = (id) => UrlParamsReplace('/sectors/:id', { id });
export const GET_ALL_SECTORS_URL = (offset, limit) => UrlParamsReplace('/sectors?offset=:offset&limit=:limit', { offset, limit });
export const UPDATE_SECTOR_STATUS_URL = (id, status) => UrlParamsReplace('/sectors-status/:id?status=:status', { id, status });
export const GET_ALL_SECTORS_FOR_USER_URL = () => UrlParamsReplace('/sectors/all');

export const CREATE_BOND_LIVES_URL = UrlParamsReplace('/bond-lives');
export const CREATE_OR_UPDATE_BONDS_URL = UrlParamsReplace('/create-bonds');
export const GET_SECTORS_URL = UrlParamsReplace('/sectors');
export const UPDATE_USER_SECTORS = UrlParamsReplace('/users-sectors');
export const USER_IRS_MANAGE_SECTORS_URL = () => UrlParamsReplace('/user-irs/manage-sectors');
export const USER_IRS_VIEW_STATE_URL = () => UrlParamsReplace('/user-irs/view-state');
export const USER_IRS_VIEW_STATE_BATCH_URL = () => UrlParamsReplace('/user-irs/view-state/batch');
export const USER_CLOB_MANAGE_BROKERS_TRADERS_URL = () => UrlParamsReplace('/user-clob/manage-brokers-traders');

export const GET_PUSH_NOTIFICATIONS_URL = () => UrlParamsReplace('/push-notification');
export const GET_BOND_ACTIONS_URL = ({ offset, limit, type, search }) => UrlParamsReplace(
    '/bond-actions?offset=:offset&limit=:limit&type=:type&search=:search',
    {
        offset,
        limit,
        type,
        search
    }
);
export const GET_TRADER_COMPANIES_URL = UrlParamsReplace('/trader-company');
export const GET_IMM_DATES_URL = ({ date, n, discardExpired } = {}) => {
    const qs = new URLSearchParams();
    if (date) qs.set('date', date);
    if (n != null) qs.set('n', n);
    if (discardExpired) qs.set('discardExpired', 'true');
    const query = qs.toString();
    return UrlParamsReplace(`/imm-dates${query ? `?${query}` : ''}`);
};
export const GET_IRS_LIST_URL = () => UrlParamsReplace('/irs/list');
export const DELETE_SECTOR_URL = (id) => UrlParamsReplace('/sectors/:id', { id });
export const GET_BONDS_BY_ISIN_URL = () => UrlParamsReplace('/get-bonds-by-isins');
// export const GET_SECTORS_WITH_BONDS_URL = ({ sectorIds }) => UrlParamsReplace('/sectors-bonds?sectorIds=:sectorIds', { sectorIds });
export const GET_SECTORS_WITH_BONDS_URL = UrlParamsReplace('/sectors-bonds');

export const CREATE_BOND_SECTOR_URL = () => UrlParamsReplace('/bond-sectors');
export const GET_MATCHING_SETTINGS_URL = () => UrlParamsReplace('/matching-settings');
export const UPDATE_MATCHING_SETTINGS_URL = () => UrlParamsReplace('/matching-settings');

export const GET_USER_DETAILS_URL = () => UrlParamsReplace('/user/details');

export const GET_ALL_TRADING_ENTITIES_URL = ({ offset, limit, phrase } = {}) => UrlParamsReplace(
    '/trading-entities?offset=:offset&limit=:limit&phrase=:phrase',
    { offset: offset ?? 0, limit: limit ?? 100, phrase: phrase ?? '' }
);
export const GET_TRADING_ENTITIES_BY_TYPE_URL = (type) => UrlParamsReplace('/trading-entities/type/:type', { type });
export const CREATE_TRADING_ENTITY_URL = () => UrlParamsReplace('/trading-entity');
export const UPDATE_TRADING_ENTITY_URL = (id) => UrlParamsReplace('/trading-entity/:id', { id });
export const DELETE_TRADING_ENTITY_URL = (id) => UrlParamsReplace('/trading-entity/:id', { id });

export const GET_NDLE_MAPPINGS_URL = ({ irsId, brokerCompanyId } = {}) => UrlParamsReplace(
    '/ndle/mappings?irsId=:irsId&brokerCompanyId=:brokerCompanyId',
    { irsId: irsId ?? '', brokerCompanyId: brokerCompanyId ?? '' }
);
export const GET_NDLE_MAPPINGS_COUNT_URL = ({ irsId, brokerCompanyId } = {}) => UrlParamsReplace(
    '/ndle/mappings/count?irsId=:irsId&brokerCompanyId=:brokerCompanyId',
    { irsId: irsId ?? '', brokerCompanyId: brokerCompanyId ?? '' }
);
export const GET_NDLE_RESOLVE_URL = ({ userId, otherUserId, irsId } = {}) => UrlParamsReplace(
    '/ndle/resolve?userId=:userId&otherUserId=:otherUserId&irsId=:irsId',
    { userId: userId ?? '', otherUserId: otherUserId ?? '', irsId: irsId ?? '' }
);
export const ADD_NDLE_MAPPING_URL = () => UrlParamsReplace('/ndle/mappings');
export const DELETE_NDLE_MAPPING_URL = () => UrlParamsReplace('/ndle/mappings');
export const GET_NDLE_CURVES_URL = () => UrlParamsReplace('/ndle/curves');
export const SEARCH_NDLE_TRADING_ENTITIES_URL = ({ search = '', excludeIds = '' } = {}) => UrlParamsReplace(
    '/ndle/trading-entities/search?search=:search&excludeIds=:excludeIds',
    { search, excludeIds }
);
export const GET_NDLE_BROKER_COMPANIES_URL = () => UrlParamsReplace('/ndle/broker-companies');
export const IMPORT_NDLE_MAPPINGS_URL = () => UrlParamsReplace('/ndle/mappings/import');
export const PARSE_NDLE_UPLOAD_URL = () => UrlParamsReplace('/ndle/mappings/upload/parse');
export const SUBMIT_NDLE_UPLOAD_URL = () => UrlParamsReplace('/ndle/mappings/upload/submit');

export const SEARCH_SECTORS_URL = ({ offset, limit, phrase }) => UrlParamsReplace(
    '/sectors/search?offset=:offset&limit=:limit&phrase=:phrase',
    { offset, limit, phrase }
);
export const DELETE_BONDS_URL = UrlParamsReplace('/bonds');
export const BOND_YAS_CALCULATION_URL = (isin) => UrlParamsReplace('/bonds/yas/:isin', { isin });
export const CREATE_INDEX_HISTORY_URL = UrlParamsReplace('/indexes-histories');
export const GET_SERVER_TIME = UrlParamsReplace('/server-time');
export const GET_INDEX_HISTORIES = (indexId) => UrlParamsReplace('/indexes-histories/:id', { id: indexId });
export const GET_HS_BOND_INDEX_HISTORIES = ({ bondId, indexName, type }) => UrlParamsReplace(
    `/indexes-histories/bonds/:bondId/HS?${indexName ? 'indexName=:indexName' : ''
    }${type ? '&type=:type' : ''}`,
    { bondId, indexName, type }
);
export const GET_BASIS_BOND_INDEX_HISTORIES = ({ bondId, indexName, type }) => UrlParamsReplace(
    `/indexes-histories/bonds/:bondId/BASIS?${indexName ? 'indexName=:indexName' : ''
    }${type ? '&type=:type' : ''}`,
    { bondId, indexName, type }
);

export const GET_TOP_NEWS_URL = (offset, limit) => UrlParamsReplace('/top-news?offset=:offset&limit=:limit', { offset, limit });

export const GET_NEWSFEED_SOURCES_URL = ({ hasBreaking } = {}) => {
    if (hasBreaking) {
        return UrlParamsReplace('/newsfeed/sources?hasBreaking=1');
    }
    return UrlParamsReplace('/newsfeed/sources');
};
export const GET_NEWSFEED_BREAKING_TWEET_COUNT_URL = () => UrlParamsReplace('/newsfeed/breaking-tweet-count');
export const GET_NEWSFEED_STATE_URL = () => UrlParamsReplace('/newsfeed/state');
export const PUT_NEWSFEED_STATE_URL = () => UrlParamsReplace('/newsfeed/state');
export const GET_NEWSFEED_STATS_URL = ({ breaking, sourceId } = {}) => {
    const params = new URLSearchParams();
    if (breaking) params.set('breaking', '1');
    if (sourceId) params.set('sourceId', sourceId);
    const qs = params.toString();
    return UrlParamsReplace(qs ? `/newsfeed/stats?${qs}` : '/newsfeed/stats');
};
export const GET_NEWSFEED_TWEETS_URL = ({
    offset = 0,
    limit = 50,
    breaking,
    sourceId
} = {}) => {
    const params = new URLSearchParams();
    params.set('offset', String(offset));
    params.set('limit', String(limit));
    if (breaking) params.set('breaking', '1');
    if (sourceId) params.set('sourceId', sourceId);
    return UrlParamsReplace(`/newsfeed/tweets?${params.toString()}`);
};
export const CREATE_INDEX_SECURITY_URL = UrlParamsReplace(
    '/indexes-securities'
);
export const CREATE_INDEX_LIVE_URL = UrlParamsReplace('/indexes-lives');

export const GET_COMPANY_NEWS_URL = (page, limit, phrase) => UrlParamsReplace('/company-news?page=:page&limit=:limit&phrase=:phrase', {
    page,
    limit,
    phrase
});

export const EDIT_USER_PROFILE_URL = (id) => UrlParamsReplace('/user/profile/:id', { id });

export const CREATE_HOLIDAY = UrlParamsReplace('/holidays');
export const UPDATE_HOLIDAY = (id) => UrlParamsReplace(`/holidays/${id}`);
export const DELETE_HOLIDAY = (id, cdrId) => UrlParamsReplace(`/holidays/${id}${cdrId ? `?cdrId=${cdrId}` : ''}`);
export const GET_HOLIDAYS = UrlParamsReplace('/holidays');
export const GET_CURRENCIES = UrlParamsReplace('/currencies');
export const CHECK_CURRENCY_HIDDEN = (id) => UrlParamsReplace('/currencies/:id/hidden', { id });
export const GET_FX_SPOT_RATE = (pair) => UrlParamsReplace('/currency-spot/rate/:pair', { pair });
export const GET_CDRS = UrlParamsReplace('/cdrs');
export const GET_CDR_HOLIDAYS = ({ codes = [], startDate, endDate }) => UrlParamsReplace('/cdr-holidays?codes=:codes&startDate=:startDate&endDate=:endDate', {
    codes: encodeURIComponent(codes.join(',')),
    startDate,
    endDate
});
export const GET_CDR_CODES = UrlParamsReplace('/cdr-holidays/codes');
export const CREATE_IRS_HISTORY_URL = UrlParamsReplace('/irs-histories');
export const GET_IRS_HISTORY = (id, legs, limit, conversion, page) => UrlParamsReplace(
    `/irs-histories/irs-bond/:id?legs=${legs}${limit ? `&limit=${limit}` : ''}${conversion ? `&conversion=${conversion}` : ''
    }${page ? `&page=${page}` : ''}`,
    { id }
);
export const GET_CDS_HISTORY = (id, legs) => UrlParamsReplace(`/cds-histories/:id?legs=${legs}`, { id });
export const GET_CURRENCY_HISTORY = (
    id,
    legs,
    spot,
    isFwdPoints = false,
    last = null
) => UrlParamsReplace(
    `/currency-histories/:id?legs=${legs}${spot ? '&spot=1' : ''
    }&isFwdPoints=${isFwdPoints}${last ? '&last=2' : ''}`,
    { id }
);
export const UPDATE_USER_STATUS_URL = (id) => UrlParamsReplace('/users/:id', { id });
export const GET_HOOT_TOKEN_URL = UrlParamsReplace('/hoot/token');
export const SESSION_LOGOUT = UrlParamsReplace('/sessions/disconnect');
export const SEND_EMAIL_URL = UrlParamsReplace('/emails/trade');
export const GET_EMAIL_URL = (id, type = 'irs') => UrlParamsReplace(`/emails/trade?id=${id}&type=${type}`);
export const DELETE_BONDS_PRICE_HISTORY_URL = UrlParamsReplace(
    '/bonds/price-histories'
);
export const CREATE_OR_UPDATE_USER_BOND = UrlParamsReplace('/users-bonds');
export const GET_TRADE_EXCEL_URL = UrlParamsReplace('/excel/trades');
export const GET_BONDS_PRICE_HISTORY_URL = (id, limit) => UrlParamsReplace(
    `/bonds/:id/price-histories?${limit ? `limit=${limit}` : ''}`,
    { id }
);
export const GET_BONDS_PRICE_HISTORY_SNP_URL = (id) => UrlParamsReplace('/bond-price-histories/:id/snp', { id });
export const GET_BONDS_PRICE_IRS_HISTORY_SNP_URL = (id) => UrlParamsReplace('/irs-histories/:id/snp', { id });
export const GET_BONDS_PRICE_CURRENCY_HISTORY_SNP_URL = (id) => UrlParamsReplace('/currency-histories/:id/snp', { id });

export const GET_USER_SECTOR_BONDS = (auto, brokerType = 'AGENCY') => UrlParamsReplace(`/user-sectors?auto=${auto}&brokerType=${brokerType}`);
export const GET_DASHBOARD_WATCHLIST = ({ sectorIds, fxVolIds, fxFwdIds } = {}) => {
    const params = new URLSearchParams();
    // Only emit when the client has an explicit array preference. `null`/`undefined`
    // means "default all-ON" (param omitted). An empty array is a real selection
    // (none) and is sent as an empty value so the API can skip tile computation.
    if (Array.isArray(sectorIds)) params.set('sectorIds', sectorIds.join(','));
    if (Array.isArray(fxVolIds)) params.set('fxVolIds', fxVolIds.join(','));
    if (Array.isArray(fxFwdIds)) params.set('fxFwdIds', fxFwdIds.join(','));
    const qs = params.toString();
    return UrlParamsReplace(`/dashboard/watchlist${qs ? `?${qs}` : ''}`);
};
export const GET_IRS_CLOB_BROKER_PRICES = (brokerType, currency, irsId) => UrlParamsReplace(`/irs-clob/broker?brokerType=${brokerType}${currency ? `&currency=${currency}` : ''}${irsId ? `&irsId=${irsId}` : ''}`);
export const GET_IRS_CLOB_TRADER_PRICES = (brokerType, currency, irsId) => UrlParamsReplace(`/irs-clob/trader?brokerType=${brokerType}${currency ? `&currency=${currency}` : ''}${irsId ? `&irsId=${irsId}` : ''}`);
export const CREATE_IRS_PRICE_URL = () => UrlParamsReplace('/irs-price');
export const CREATE_IRS_MARKET_URL = () => UrlParamsReplace('/irs-price/market');
export const CANCEL_IRS_MATCHINGS_URL = () => UrlParamsReplace('/irs-clob/cancel-interest');
export const CHANGE_IRS_PRICE_TRADER_URL = () => UrlParamsReplace('/irs-clob/change-price-trader');
export const UPDATE_IRS_PRICE_COMMENT_URL = () => UrlParamsReplace('/irs-clob/price-comment');
export const CANCEL_BOND_PRICE_URL = (id) => UrlParamsReplace(`/bond-price/${id}`);
export const RESTORE_INACTIVE_PRICE_URL = () => UrlParamsReplace('/restore-inactive-price');
export const SECURITIES_TRADE_URL = () => UrlParamsReplace('/securities/trade');
export const SECURITIES_IMPLIED_TRADE_URL = () => UrlParamsReplace('/securities/implied-trade');
export const GET_BROKER_SELF_PRICE_NOTIFICATIONS_URL = () => UrlParamsReplace('/broker-self-price-notifications');
export const DISMISS_BROKER_SELF_PRICE_NOTIFICATION_URL = (id) => UrlParamsReplace(`/broker-self-price-notifications/${id}`);
export const RETIRE_LANDING_PAGE_URL = () => UrlParamsReplace('/user/landing-page/retire');
export const GET_FXO_VOL_HISTORY = ({ id, tradeType, delta, tenor, plotStart }) => UrlParamsReplace(
    `/fxo-vol-histories/:id?tradeType=${tradeType}&delta=${delta}${tenor ? `&tenor=${tenor}` : ''}${plotStart ? `&plotStart=${encodeURIComponent(plotStart)}` : ''}`,
    { id }
);
export const GET_FXO_VOL_HISTORY_RAW = (id) => UrlParamsReplace('/fxo-vol-histories-raw/:id', { id });
export const GET_FXO_VOL_SMILE_TENOR = ({ id, tenor }) => UrlParamsReplace(`/fxo-vol-smile-tenor/:id?tenor=${tenor}`, { id });
export const GET_FXO_VOL_SMILE_PRICE = ({
    id,
    tradeType: t,
    delta: d,
    optionType: o
}) => UrlParamsReplace(
    `/fxo-vol-smile-price/:id?tradeType=${t}&delta=${d}&optionType=${o}`,
    { id }
);

export const FX_OPTIONS_CURRENCY = (ticker) => UrlParamsReplace(`/fx-options/currency-pairs/${ticker}`);
export const FX_OPTIONS_CURRENCIES = () => UrlParamsReplace('/fx-options/currency-pairs');
export const FX_OPTIONS_CURRENCY_GROUPS = () => UrlParamsReplace('/fx-options/currency-groups');
export const FX_OPTIONS_FORWARD_RATE = () => UrlParamsReplace('/fx-options/forward-rate');
export const FX_OPTIONS_EXPIRY_DATE = () => UrlParamsReplace('/fx-options/calculate-expiry-date');
export const DSLICE_GRID = () => UrlParamsReplace('/fx-options/calculate-dslice-grid');

export const GET_FXO_RVOL_VS_IVOL_BATCH = ({ pair, rvolTenors, ivolTenors, lookback, commandTenor }) => UrlParamsReplace(
    `/fxo-rvol-vs-ivol-batch?pair=${pair}&rvolTenors=${encodeURIComponent(rvolTenors)}`
    + `&ivolTenors=${encodeURIComponent(ivolTenors)}&lookback=${lookback}&commandTenor=${commandTenor}`
);

export const GET_UMBRELLA_ORGS = () => UrlParamsReplace('/umbrella-org');
export const UMBRELLA_ORGS = () => UrlParamsReplace('/umbrella-org');
export const MAKE_COMPANY_ADMIN = () => UrlParamsReplace('/umbrella-org/company-admin');

export const GET_UMBRELLA_ORGS_TEAMS = (umbrellaOrgId) => UrlParamsReplace(`/umbrella-org-teams?umbrellaOrgId=${umbrellaOrgId}`);
export const UMBRELLA_ORGS_TEAMS = () => UrlParamsReplace('/umbrella-org-teams');
export const GET_IRS_FORWARDS_HISTORY = (id, legs, plotRange, imm, conversion) => UrlParamsReplace(`/irs-forwards/irs/:id?legs=${legs}&plotUnit=${plotRange?.unit}&plotValue=${plotRange?.value}${imm ? `&imm=${imm}` : ''}${conversion ? `&conversion=${conversion}` : ''}`, { id });
export const GET_IRS_FORWARDS_TEST_URL = (id, legs, plotUnit, plotValue) => UrlParamsReplace(`/irs-forwards-test/irs/:id?legs=${encodeURIComponent(legs)}&plotUnit=${plotUnit}&plotValue=${plotValue}`, { id });
export const BOB_6S3S_CURVE_TEST_URL = () => UrlParamsReplace('/swaps/bob-6s3s-curve-test');
export const BOB_6S3S_PLOT_URL = () => UrlParamsReplace('/swaps/bob-6s3s/plot');
export const GET_IRS_EDGE_URL = ({ id, startDate, endDate }) => UrlParamsReplace('/irs-edges/irs/:id?startDate=:startDate&endDate=:endDate', { id, startDate, endDate });
export const GET_IRS_ANCHOR_URL = ({ id, range, convention }) => UrlParamsReplace(`/anchors/irs/:id${convention ? '?convention=1' : ''}`, { id });
export const GET_IRS_BGC_DATA = (id, days) => UrlParamsReplace('/irs-bgc/:id?days=:days', { id, days });
export const GET_IRS_RC_DETAILS2 = (id, legs, meetingDateLabels, horizons) => UrlParamsReplace(`/irs-rc/forward-rate-2/:id?legs=${legs}${meetingDateLabels ? `&meetingDateLabels=${meetingDateLabels}` : ''}${horizons ? `&horizons=${horizons}` : ''}`, { id });
export const GET_IRS_RC_FWD_BATCH_URL = () => UrlParamsReplace('/irs-rc/forward-rate-batch');

export const GET_IRS_SECURITY_BY_IRS_ID_TERM = ({ irsId, term }) => UrlParamsReplace(
    '/irs-securities?irsId=:irsId&term=:term',
    { irsId, term: encodeURIComponent(term || '') }
);

export const LLM_RESPONSE_URL = () => UrlParamsReplace('/llms/response');
export const SEARCH_IRS_URL = () => UrlParamsReplace('/irs/search');
export const GET_IRS_RC_DETAILS3 = (id, horizons) => UrlParamsReplace(`/irs-rc/forward-rate-3/:id?${horizons ? `horizons=${horizons}` : ''}`, { id });

export const GET_ALL_CURRENCY = () => UrlParamsReplace('/currencies-list');
export const GET_ALL_FXO_CURRENCY = () => UrlParamsReplace('/fxo-list');
export const CREATE_SDR_FILTER = () => UrlParamsReplace('/sdr-filter');
export const SDR_FILTER = (id) => UrlParamsReplace('/sdr-filter/:id', { id });
export const GET_ALL_USER_SDR_FILTER = (category) => UrlParamsReplace(`/sdr-filters?category=${category}`);
export const GET_SDR_TRADE_EXCEL_URL = UrlParamsReplace('/excel/dtcc-trades');
export const UPDATE_SDR_FILTER = (id, category) => UrlParamsReplace(`/user-sdr-filter/:id?category=${category}`, { id });
export const GET_OLDEST_DTCC_TRADE_TIME = (irsId) => {
    const url = irsId
        ? `/oldest-dtcc-trade-time?irsId=${irsId}`
        : '/oldest-dtcc-trade-time';
    return UrlParamsReplace(url);
};

export const USER_PREFERENCE = () => UrlParamsReplace('/user-preference');

export const CHRONOS_DV01_SUMAARY = () => UrlParamsReplace('/dv01-summary');
export const CHRONOS_TRADE_LEVEL_SUMAARY = () => UrlParamsReplace('/trade-over-time');
export const CHRONOS_MEETING_DATES = () => UrlParamsReplace('/meeting-dates');

export const GET_REGRESS = () => UrlParamsReplace('/regress');
export const TRIGGER_THOR_CURVE = () => UrlParamsReplace('/swaps/thor-curve-trigger');
export const FETCH_THOR_CURVE_PROGRESS = () => UrlParamsReplace('/swaps/thor-curve-progress');
export const FETCH_THOR_CURVE = () => UrlParamsReplace('/swaps/thor-curve-fetch');
export const DELETE_THOR_CURVE = () => UrlParamsReplace('/swaps/thor-curve-delete');
export const POST_IRS_ANCHOR_HEATMAP = () => UrlParamsReplace('/irs-anchor/heatmap');
export const POST_IRS_ANCHOR_SERIES = () => UrlParamsReplace('/irs-anchor/series');
export const POST_IRS_PLOTF_URL = () => UrlParamsReplace('/irs-plotf');
export const BULK_UPDATE_MEETING_DATES_URL = (id) => UrlParamsReplace('/meeting-dates/bulk-update');

export const GET_IRS_CTA = (data) => UrlParamsReplace(`/cta/irs?debug=${data.debug}`);

export const CALCULATE_NDF_ZERO_RATES = () => UrlParamsReplace('/ndf/zero-rates');
export const CALCULATE_NDF_ZERO_RATES_HISTORY = () => UrlParamsReplace('/ndf/zero-rates/history');
export const FETCH_CURRENCY_SPOT_HISTORY = () => UrlParamsReplace('/currency-spot/history');
export const CALCULATE_NDF_FWD_RATES = () => UrlParamsReplace('/ndf/fwd-rates');
export const CALCULATE_NDF_FWD_RATES_HISTORY = () => UrlParamsReplace('/ndf/fwd-rates/history');
export const GET_IRS_CTA_BY_CCY = ({
    ccy,
    debug = false,
    history = false,
    limit = 21,
    scenarioRatesBps = 0,
    scenarioDays = 'INSTANT'
}) => UrlParamsReplace(
    `/cta/irs/ccy?ccy=${ccy}&debug=${debug}&history=${history}&limit=${limit}&scenarioRatesBps=${scenarioRatesBps}&scenarioDays=${scenarioDays}`
);

export const GET_FOREX_CTA_BY_PAIR = ({
    pair,
    lookbackDays = 252,
    withProjection = true
}) => UrlParamsReplace(
    `/cta/forex/pair?pair=${pair}&lookbackDays=${lookbackDays}&withProjection=${withProjection}`
);

export const GET_FOREX_CTA_TICKERS = () => UrlParamsReplace('/cta/forex/tickers');

export const GET_EQUITY_CTA_BY_TICKERS = ({
    tickers = [],
    withProjection = true,
    lookbackDays = 252
}) => UrlParamsReplace(
    `/cta/equities?tickers=${encodeURIComponent((tickers || []).join(','))}&withProjection=${withProjection}&lookbackDays=${lookbackDays}`
);
